import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { McpIcon } from './icons';
import CapabilityPill from './CapabilityPill';
import { useTranslation } from '../i18n/useTranslation';

interface Props {
  isMcp?: boolean | null;
  hasAi?: boolean | null;
}

const AI_COLOR = '#6366F1';

/**
 * Subtle capability badges for a workflow: MCP when it is exposed as an MCP tool,
 * AI when it contains an AI step. Renders nothing when neither applies.
 */
export default function WorkflowBadges({ isMcp, hasAi }: Props) {
  const t = useTranslation();
  if (!isMcp && !hasAi) return null;

  return (
    <Box sx={{ display: 'inline-flex', gap: 0.75, alignItems: 'center' }}>
      {isMcp && (
        <CapabilityPill
          label={t('workflow.badge.mcp')}
          tooltip={t('workflow.badge.mcpTooltip')}
          color="primary.main"
          bg={(theme) => alpha(theme.palette.primary.main, 0.1)}
          icon={<McpIcon sx={{ fontSize: 13, color: 'primary.main' }} />}
        />
      )}
      {hasAi && (
        <CapabilityPill
          label={t('workflow.badge.ai')}
          tooltip={t('workflow.badge.aiTooltip')}
          color={AI_COLOR}
          bg={alpha(AI_COLOR, 0.1)}
          icon={<AutoAwesomeIcon sx={{ fontSize: 13, color: AI_COLOR }} />}
        />
      )}
    </Box>
  );
}
